import PropTypes from 'prop-types';
import { Grid2 as Grid, Typography } from '@mui/material';
import { t } from 'i18next';
import { TextFieldName } from '../../Users/forms/textFieldName';
import { BirthdatePicker } from '../../Users/forms/birthdatePicker';
import { SexSelector } from '../../Users/forms/sexSelector';
import { GenderSelector } from '../../Users/forms/genderSelector';
import { TextFieldPhone } from '../../Users/forms/textFieldPhone';
import { HealthSystemSelector } from '../../Users/forms/healthSystemSelector';
import { TextFieldEmail } from '../../Users/forms/textFieldEmail';
import { TextFieldProfessionalCertificate } from '../../Users/forms/textFieldProfessionalCertificate';
import { TextFieldHealthSystemNumber } from '../../Users/forms/textFieldHealthSystemNumber';
import { TextFieldSpeciality } from '../../Users/forms/textFieldSpeciality';
import { TextFieldAddress } from '../../Users/forms/textFieldAddress';
import { TextFieldZip } from '../../Users/forms/textFieldZip';
import { TextFieldCity } from '../../Users/forms/textFieldCity';
import { CommonCard } from 'component/cards/MainCard2';

function PersonalBodyCard({ formik }) {
    return (
        <CommonCard sx={{ p: 2 }}>
            <Grid container columnSpacing={4} rowSpacing={2} sx={{ width: '100%' }}>
                <Grid size={12}>
                    <Typography variant="h5">{t('users.identification')}</Typography>
                </Grid>
                <Grid size={8}>
                    <TextFieldName {...formik} />
                </Grid>
                <Grid size={4}>
                    <BirthdatePicker {...formik} />
                </Grid>
                <Grid size={6}>
                    <TextFieldEmail {...formik} />
                </Grid>
                <Grid size={3}>
                    <SexSelector {...formik} />
                </Grid>
                <Grid size={3}>
                    <GenderSelector {...formik} />
                </Grid>
                <Grid size={4}>
                    <TextFieldPhone {...formik} />
                </Grid>
                <Grid size={4}>
                    {formik.values.type === 0 ? (
                        <HealthSystemSelector {...formik} />
                    ) : (
                        <TextFieldProfessionalCertificate {...formik} />
                    )}
                </Grid>
                <Grid size={4}>
                    {formik.values.type === 0 ? (
                        <TextFieldHealthSystemNumber {...formik} />
                    ) : (
                        <TextFieldSpeciality {...formik} />
                    )}
                </Grid>
                <Grid size={12}>
                    <Typography variant="h5">{t('users.location')}</Typography>
                </Grid>
                <Grid size={7}>
                    <TextFieldAddress {...formik} />
                </Grid>
                <Grid size={2}>
                    <TextFieldZip {...formik} />
                </Grid>
                <Grid size={3}>
                    <TextFieldCity {...formik} />
                </Grid>
            </Grid>
        </CommonCard>
    );
}

PersonalBodyCard.propTypes = {
    formik: PropTypes.object.isRequired
};

export default PersonalBodyCard;
